import { render, staticRenderFns } from "./MyQuotationCommodityCreate.vue?vue&type=template&id=1c087c34&"
import script from "./MyQuotationCommodityCreate.vue?vue&type=script&lang=js&"
export * from "./MyQuotationCommodityCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c087c34')) {
      api.createRecord('1c087c34', component.options)
    } else {
      api.reload('1c087c34', component.options)
    }
    module.hot.accept("./MyQuotationCommodityCreate.vue?vue&type=template&id=1c087c34&", function () {
      api.rerender('1c087c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationCommodity/MyQuotationCommodityCreate.vue"
export default component.exports